import React, { useState, createContext, ReactNode, useMemo, useContext } from 'react'

type CartProductsContextType = {
   productsCount: number
   setProductsCount: (count: number) => void
}

export const CartProductsContext = createContext<CartProductsContextType>({
   productsCount: 0,
   setProductsCount: () => {},
})

export function useCartProductsContext() {
   const { productsCount, setProductsCount } = useContext(CartProductsContext)
   return { productsCount, setProductsCount }
}

function CartProductsProvider({ children }: { children: ReactNode }) {
   const [count, setCount] = useState<number>(0)

   function setProductsCount(c: number) {
      setCount(c)
   }

   const contextValue: CartProductsContextType = useMemo(
      () => ({
         productsCount: count,
         setProductsCount,
      }),
      [count]
   )

   return <CartProductsContext.Provider value={contextValue}>{children}</CartProductsContext.Provider>
}

export default CartProductsProvider
